import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Villas from "./pages/Villas";
import Terrains from "./pages/Terrains";
import Appartements from "./pages/Appartements";
import Projects from "./pages/Projects";
import PropertyDetail from "./pages/PropertyDetail";
import Contact from "./pages/Contact";
import { Toaster } from "./components/ui/sonner";
import { Outlet } from "react-router-dom";

// Backoffice imports
import Login from "./pages/backoffice/Login";
import Dashboard from "./pages/backoffice/Dashboard";
import BackofficeProperties from "./pages/backoffice/Properties";
import PropertyForm from "./pages/backoffice/PropertyForm";
import Requests from "./pages/backoffice/Requests";
import Users from "./pages/backoffice/Users";
import Testimonials from "./pages/backoffice/Testimonials";

function PublicLayout({ children }) {
  return (
    <div>
      <Header />
      <main>{children}</main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Routes>
            {/* Public routes with Header and Footer */}
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
            <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
            <Route path="/villas" element={<PublicLayout><Villas /></PublicLayout>} />
            <Route path="/terrains" element={<PublicLayout><Terrains /></PublicLayout>} />
            <Route path="/appartements" element={<PublicLayout><Appartements /></PublicLayout>} />
            <Route path="/projects" element={<PublicLayout><Projects /></PublicLayout>} />
            <Route path="/property/:id" element={<PublicLayout><PropertyDetail /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />

            {/* Backoffice routes without Header and Footer */}
            <Route path="/backoffice/login" element={<Login />} />
            <Route path="/backoffice/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/backoffice/properties" element={
              <ProtectedRoute>
                <BackofficeProperties />
              </ProtectedRoute>
            } />
            <Route path="/backoffice/properties/new" element={
              <ProtectedRoute>
                <PropertyForm />
              </ProtectedRoute>
            } />
            <Route path="/backoffice/properties/edit/:id" element={
              <ProtectedRoute>
                <PropertyForm />
              </ProtectedRoute>
            } />
            <Route path="/backoffice/requests" element={
              <ProtectedRoute>
                <Requests />
              </ProtectedRoute>
            } />
            <Route path="/backoffice/users" element={
              <ProtectedRoute requiredRole="ADMIN">
                <Users />
              </ProtectedRoute>
            } />
            <Route path="/backoffice/testimonials" element={
              <ProtectedRoute requiredRole="ADMIN">
                <Testimonials />
              </ProtectedRoute>
            } />
          </Routes>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
